import { Grid, InputLabel as MUIInputLabel, SxProps, Typography } from '@mui/material';
import { FunctionComponent } from 'react';
import { ColorPalette } from 'shared/consts/colorPalette';

interface Props {
	name: string;
	label: string;
	required?: boolean;
	sx?: SxProps;
}

export const InputLabel: FunctionComponent<Props> = ({ name, label, required, sx }) => {
	return (
		<MUIInputLabel
			shrink
			htmlFor={name}
			sx={{
				'&.MuiInputLabel-root': {
					display: 'inline-table',
				},
				...sx,
			}}
		>
			<Grid container>
				<Typography variant={'body1'} color={ColorPalette.astronaut}>
					{label}
				</Typography>
				{required && (
					<Typography variant={'body2'} color={ColorPalette.royalBlue}>
						*
					</Typography>
				)}
			</Grid>
		</MUIInputLabel>
	);
};
